import { render, staticRenderFns } from "./FAQPremium.vue?vue&type=template&id=697e36b0&scoped=true"
import script from "./FAQPremium.vue?vue&type=script&lang=js"
export * from "./FAQPremium.vue?vue&type=script&lang=js"
import style0 from "./FAQPremium.vue?vue&type=style&index=0&id=697e36b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697e36b0",
  null
  
)

export default component.exports